import { EntityRelationsGraph } from './EntityRelationsGraph';
import {
  RELATION_DEPENDENCY_OF,
  RELATION_DEPENDS_ON,
} from '@backstage/catalog-model';
import { entityUtil } from '@appfolio/backstage-plugin-catalog-common';
import { ANNOTATION_PACKAGE_TYPE } from '@appfolio/backstage-plugin-catalog-common';
import { useFrontendEntityRefOptions } from '../../hooks/useFrontendEntityRefOptions';

export const FrontendDependencyGraph = () => {
  const { options } = useFrontendEntityRefOptions();
  return (
    <EntityRelationsGraph
      title="Front-end Dependencies"
      options={options}
      entityFilter={entity => {
        const e = entityUtil(entity);
        return e.isAnnotatedWith(ANNOTATION_PACKAGE_TYPE, 'npm');
      }}
      relations={[RELATION_DEPENDS_ON, RELATION_DEPENDENCY_OF]}
    />
  );
};
